import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { moviesSlice } from "@common/redux/slices/entities.slice"
import { Layout } from "@kursk/components/Layout/Layout";
import styles from './Movies.module.scss';
import { Filters } from "../../ui/Filters/Filters";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import { MoviesGrid } from "./MoviesGrid/MoviesGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import React from "react";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

export const Movies = () => {
  const { total, meta, filters } = useSelectSlice(moviesSlice);
  const selectedGenres = filters.genres;

  return (
    <Layout showSubscribePopup={false}>
      <SeoMetaTitles
        page="movies"
        titleOg={getEntitiesListTitle(meta.tags, selectedGenres, 'киноафиша')}
        meta={meta}
      />
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            page="movies"
            tags={meta.genres}
            selectedTags={selectedGenres}
            title={'киноафиша'}
            dashTitle={'Найдено фильмов'}
            total={total}
            genres={meta.genres}
          />
        </div>
        <div className={styles.filters}>
          <Filters
            entityType={'movies'}
            meta={meta}
            filters={filters}
            withDates/>
        </div>
        <div className={styles.items}>
          <MoviesGrid/>
        </div>
        <div className={styles.subscribeSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
